export const fromWindow = (w: typeof window): Location => w.location;
export const path = ({ pathname }: Location): string => pathname.split("/")[1];
